export default function MediaRoute() {
	return <p>Media</p>
}
